import script from "./CollectivitesMembres.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesMembres.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesMembres.vue?vue&type=style&index=0&id=874fe34a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-874fe34a"]])

export default __exports__